import {Injectable} from '@angular/core';
import {ConfigService} from '../service/config.service';
import {EmiSchedule} from '@finzy/node-emi-calculator/lib/models/EmiSchedule';
import * as moment from 'moment';

@Injectable()
export class CashFlowGenerator {
    private readonly configService: ConfigService;

    constructor(configService: ConfigService) {
        this.configService = configService;
    }

    public generateForEmiSchedule(emiSchedule: EmiSchedule): CashFlow[] {
        const commissionPercentage = this.configService.getCommissionPercentage();
        const gstPercentage = this.configService.getGstPercentage();
        const emiGracePeriodInDays = this.configService.getEmiGracePeriodInDays();
        return emiSchedule.map(emi => {
            const commission = commissionPercentage * emi.emi_amount / 100;
            const gst = gstPercentage * commission / 100;
            return <CashFlow>{
                date: moment(emi.due_on).add(emiGracePeriodInDays, 'days').toDate(),
                amount: emi.emi_amount - commission - gst
            };
        });
    }

    public generateForInvestment(amount: number, date: Date): CashFlow {
        return <CashFlow>{date: date, amount: -amount};
    }
}

export interface CashFlow {
    date: Date;
    amount: number;
}